import { useDisplayOptionContext } from "@/hooks/useDisplayOptionContext";
import { useDispatch } from "react-redux";
import { useFacility } from "@/hooks/useFacility";
import { translateWithMultipleSources } from "@/lib/translate";
import { AppLocation, FunnelType, Step } from "@/types/enums";
import { emitUnitEvent } from "@/utils/units/unitEvents";
import { initializeJourney } from "@/features/journey/journeySlice";
import { UnitGroup } from "@/types";
import { getSteps } from "@/hooks/useSteps";

export const useRentalAction = (
    unitGroup: UnitGroup,
    selectedPromo: number,
) => {
    const dispatch = useDispatch();
    const { rentalApp, language, buttonLayout } = useDisplayOptionContext();
    const unitId = unitGroup.representative_unit.id;
    const facilityId = unitGroup.representative_unit.facility_id;

    const { facility } = useFacility(facilityId);

    const openVbp = () => {
        const subGroupCount = unitGroup.sub_groups?.length ?? 0;
        const steps = getSteps(subGroupCount, buttonLayout);

        dispatch(
            initializeJourney({
                unitId,
                unitGroup,
                selectedPromo,
                stepList: steps,
                step: Step.VBP,
            }),
        );
    };

    const redirectToExternalRental = (unitId: number) => {
        if (rentalApp?.externalUrl && facility) {
            sessionStorage.setItem("facilityUrl", window.location.href);
            // Build the rental url.
            const url = translateWithMultipleSources(
                rentalApp.externalUrl || "",
                {
                    unitGroup,
                    facility,
                    promo: { id: selectedPromo },
                },
                unitId,
                selectedPromo,
            );

            // Redirect to the rental url.
            window.location.assign(url);
        } else {
            // Sussy.
            console.error(
                "External rental URL or facility information is missing.",
            );
        }
    };

    const openSamePageRentalFunnel = (unitId: number) => {
        const subGroupCount = unitGroup.sub_groups?.length ?? 0;
        const steps = getSteps(subGroupCount, buttonLayout);

        emitUnitEvent(unitId, facilityId, selectedPromo, "rental");
        dispatch(
            initializeJourney({
                unitId,
                unitGroup,
                selectedPromo,
                stepList: steps,
                step: Step.FUNNEL,
                funnelType: FunnelType.RENT,
            }),
        );
    };

    const openRentalFunnel = (selectedUnitId?: number) => {
        if (rentalApp?.location === AppLocation.EXTERNAL) {
            redirectToExternalRental(selectedUnitId ?? unitId);
        } else {
            openSamePageRentalFunnel(selectedUnitId ?? unitId);
        }
    };

    const label = language?.action?.rentButton || "Rent";

    return { openRentalFunnel, openVbp, label };
};
